import { render } from "./admin-access-page.vue?vue&type=template&id=02fe5766&scoped=true"
import script from "./admin-access-page.vue?vue&type=script&lang=js"
export * from "./admin-access-page.vue?vue&type=script&lang=js"

import "./admin-access-page.vue?vue&type=style&index=0&id=02fe5766&lang=scss&scoped=true"
import "./admin-access-page.vue?vue&type=style&index=1&id=02fe5766&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fe5766"]])

export default __exports__